/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;



//////////////////
// WEBPACK FOOTER
// ./~/lodash/_listCacheClear.js
// module id = WxI4
// module chunks = 64